import React, { useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { handleTimeChange } from '@mummssoftware/utils/visitUtils';
import { VisitContext } from '../Context/contexts/VisitContext';
import { SET_CC_TIME } from '../Context/constants';
import { TimerDiv, EditTimeDiv, TimerText } from '../../components';
import { useStyles } from './style';
import defaults from '../../translations/en.json';

type CCTimerProps = {
  isCCRoleGroup: boolean;
};
/*
 * CCTimer is only available to users in the Nurse or Aide role group
 * continuous care time can not be greater than the visit duration: checked in DurationPrompt on submit
 */
export const CCTimer = ({ isCCRoleGroup }: CCTimerProps) => {
  const classes = useStyles();
  const timerId = 'hour-edit';
  const { dispatchVisit, visitError, ccTime } = useContext(VisitContext);

  const hour = ccTime ? ccTime[0] : '00';
  const minute = ccTime ? ccTime[1] : '00';

  const onHourChange = (event: any) => {
    dispatchVisit({
      type: SET_CC_TIME,
      payload: [event.target.value, minute],
    });
  };

  const onMinChange = (event: any) => {
    dispatchVisit({
      type: SET_CC_TIME,
      payload: [hour, event.target.value],
    });
  };

  const inputProps = {
    classes: {
      input: classes.input,
      root: visitError ? classes.outlinedError : classes.outlined,
    },
  };
  const handleHourChange = handleTimeChange(onHourChange);
  const handleMinChange = handleTimeChange(onMinChange);

  return (
    <EditTimeDiv className="edit-time-div">
      <FormHelperText
        id="component-helper-text"
        style={{ paddingBottom: '5px' }}
        disabled={!isCCRoleGroup}
      >
        {defaults.editCC}
      </FormHelperText>
      <TimerDiv edit>
        <TextField
          label="HH"
          id={timerId}
          variant="outlined"
          value={hour}
          InputProps={inputProps}
          onChange={handleHourChange}
          disabled={!isCCRoleGroup}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{ maxLength: 2 }}
          InputLabelProps={{
            shrink: true,
            classes: { root: classes.labelInput },
          }}
        />
        <TimerText>:</TimerText>
        <TextField
          label="MM"
          id="min-edit"
          variant="outlined"
          value={minute}
          InputProps={inputProps}
          onChange={handleMinChange}
          disabled={!isCCRoleGroup}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{ maxLength: 2 }}
          InputLabelProps={{
            shrink: true,
            classes: { root: classes.labelInput },
          }}
        />
      </TimerDiv>
    </EditTimeDiv>
  );
};

export default CCTimer;
